module.exports = __webpack_public_path__ + "img/logo.3b54dd99.png";